import { showToast } from "@/lib/utils/toast";
import { userService } from "@/features/user-management/services/user.service";
import { dataEntryService } from "../services/data-entry.services";
import { assignmentStore } from "../stores/assignment.store";
import { resolveDisclosureId } from "../domains/assignment";

export const loadAssignments = async () => {
  assignmentStore.setLoading(true);
  try {
    const assignments = await dataEntryService.listAssignments({});
    assignmentStore.setAssignments(assignments || []);
  } catch {
    showToast.error("Failed to load assignments");
  } finally {
    assignmentStore.setLoading(false);
  }
};

export const loadCompanyUsers = async () => {
  try {
    const res = await userService.listUsers();
    assignmentStore.setCompanyUsers(res.items || []);
  } catch {
    showToast.error("Failed to load users");
  }
};

export const createAssignment = async ({
  disclosureId,
  framework,
  email,
  organizationId,
}) => {
  const promise = dataEntryService.createAssignment({
    disclosureId,
    framework,
    email,
    organizationId,
  });

  showToast.promise(promise, {
    loading: "Assigning disclosure...",
    success: "Disclosure assigned",
    error: "Failed to assign disclosure",
  });

  const assignment = await promise;
  const discId = resolveDisclosureId(assignment);
  assignmentStore.setAssignment(discId, assignment);
  return assignment;
};

export const removeAssignment = async (disclosureId) => {
  const assignment = assignmentStore.getAssignment(disclosureId);
  if (!assignment) return;

  const promise = dataEntryService.removeAssignment(assignment._id);

  showToast.promise(promise, {
    loading: "Removing assignment...",
    success: "Assignment removed",
    error: "Failed to remove assignment",
  });

  await promise;
  assignmentStore.removeAssignmentByDisclosureId(disclosureId);
};
